import type { TOptional } from '@/types/common';

import { INTERACTIVE_ELEMENTS_SELECTOR } from '../constants';

const getFirstFocusable = (container: HTMLElement, nodeSelector?: string): TOptional<HTMLElement> =>
  container.querySelector<HTMLElement>(nodeSelector || INTERACTIVE_ELEMENTS_SELECTOR) || undefined;

export default getFirstFocusable;
